export default (valor) => {
  let txt = ''
  let x = Math.round(valor / 1000, 1)
  let y = valor / 1000
  let valueTxt = ''
  if (x === y) {
    valueTxt = y.toString()
  } else {
    valueTxt = x.toString()
  }

  txt = x > 0 ? valueTxt + ' Mil' : txt
  x = Math.floor((valor / 1000000) * 10) / 10
  y = valor / 1000000

  if (x === y) {
    valueTxt = y.toString()
  } else {
    valueTxt = x.toString()
  }

  txt =
    y === 1 || (y > 1 && y < 2) ? valueTxt.replace('.', ',') + ' Milhão' : txt
  txt = y >= 2 ? valueTxt.replace('.', ',') + ' Milhões' : txt

  if (y > 1000) {
    valueTxt = Math.floor((y / 1000) * 10) / 10
    txt = valueTxt.replace('.', ',') + (valueTxt > 1 ? ' Bilhões' : ' Bilhão')
  }

  if (!txt.length) {
    txt = valor.toString()
  }

  return txt
}
